module.exports = __webpack_public_path__ + "static/media/news-company-logo.033ae0a0.jpg";